import { Component, h, Prop } from '@stencil/core';
import { User } from '../../../../icons';

@Component({
  tag: 'ugc-qna-avatar',
  shadow: false,
})
export class UgcQnaAvatar {
  @Prop() profileImageUrl: string = '';
  @Prop() customerProfileLink: string = '';

  render() {
    const linkMe = `/me/${this.customerProfileLink}`;
    if (!this.customerProfileLink) {
      if (this.profileImageUrl) {
        return <img src={this.profileImageUrl} class="w-32 h-32 rounded-50" alt="" />;
      }
      return (
        <span class="flex-row-center-center w-32 h-32 p-8 rounded-50 bg-gray-300">
          <User />
        </span>
      );
    }
    if (this.profileImageUrl) {
      return (
        <a href={linkMe}>
          <img src={this.profileImageUrl} class="w-32 h-32 rounded-50" alt="" />
        </a>
      );
    }
    return (
      <a href={linkMe} class="flex-row-start-start">
        <span class="flex-row-center-center w-32 h-32 p-8 rounded-50 bg-gray-300">
          <User />
        </span>
      </a>
    );
  }
}
